import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import ResizeObserver from "resize-observer-polyfill";
// import SvgMountain1 from "../components/svg/Mountain1";
// import SvgMountain2 from "../components/svg/Mountain2";
// import SvgMountain3 from "../components/svg/Mountain3";
// import SvgMountain4 from "../components/svg/Mountain4";
// import SvgTrees from "../components/svg/trees";
// import SvgStars from "../components/svg/stars";

export default class AnimatedBackground extends Component {
	constructor(props) {
		super(props);

		this._docHeight = 1;
		this._docWidth = 0;
		this._vpHeight = 0;
		this._vpWidth = 0;
		this._scrollLeft = 0;
		this._scrollTop = 0;
		this._progress = 0;
		this._layers = [];

		this.state = {
			effects: [],
			scrolledToBtm: false
		};

		this._svg1 = "";
	}

	componentDidMount() {
		window.addEventListener("resize", this.onResize);
		document.addEventListener("scroll", this.onScroll);

		this.setDimensions();
		this.calcEffects();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize);
		document.removeEventListener("scroll", this.onScroll);
	}

	setDimensions = () => {
		this._docWidth =
			document.width !== undefined ? document.width : document.body.offsetWidth;
		this._docHeight =
			document.height !== undefined
				? document.height
				: document.body.offsetHeight;
		this._vpHeight = Math.max(window.innerHeight || 0);
		this._vpWidth = Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0,
			1280
		);
		this._scrollLeft =
			window.pageXOffset || document.documentElement.scrollLeft;
		this._scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	};

	onResize = () => {
		if (this._docWidth !== document.body.offsetWidth) this.setDimensions();
	};

	onScroll = event => {
		this._scrollLeft =
			window.pageXOffset || document.documentElement.scrollLeft;
		this._scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.calcProgress();
		// this.throttled(2000, this.calcEffects());
		this.calcEffects();
	};

	throttled(delay, fn) {
		let lastCall = 0;
		return function(...args) {
			const now = new Date().getTime();
			if (now - lastCall < delay) {
				return;
			}
			lastCall = now;
			return fn(...args);
		};
	}

	calcProgress = () => {
		let { scrolledToBtm } = this.state;

		this._progress = this._scrollTop / (this._docHeight - this._vpHeight);

		if (this._progress > 0.95) {
			this.setState({
				scrolledToBtm: true
			});
		} else if (scrolledToBtm) {
			this.setState({
				scrolledToBtm: false
			});
		}
	};

	calcEffects = () => {
		const { _layers } = this;
		let effects = [];

		// if (this._progress < 1) {
		_layers.map((layer, index) => {
			effects.push({
				transform: `translateX(${layer.dataset.travel *
					this._progress *
					-1}px) translateZ(0)`
				// transform: `translate3d(${layer.dataset.travel * this._progress * -1}px, 0, 0)`
				// transform: `translate3d(${Math.ceil(
				//     layer.dataset.travel * this._progress * -1
				// )}px, 0, 0)`
			});
		});
		// } else {
		// 	console.log("this._progress", this._progress);
		// }
		this.setState({
			effects
		});
	};

	addLayer = layer => {
		this._layers.push(layer);
	};

	render() {
		const { effects, scrolledToBtm } = this.state;
		let vEffects = [...effects];

		return (
			<div className="parallax-bg-wrap">
				<div className="fixed-block">
					<div
						className={`svg-wrap layer stars ${scrolledToBtm ? "active" : ""}`}>
						<object data="/images/background/v2/stars.svg">
							<img src="/images/background/v2/stars.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer trees"
						data-travel="1000"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/trees.svg"
							width={this._vpWidth + 1000}>
							<img src="/images/background/v2/trees.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain1"
						data-travel="400"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_1.svg"
							width={this._vpWidth + 400}>
							<img src="/images/background/v2/Mountain_1.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain2"
						data-travel="600"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_2.svg"
							width={this._vpWidth + 600}>
							<img src="/images/background/v2/Mountain_2.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain3"
						data-travel="800"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_3.svg"
							width={this._vpWidth + 800}>
							<img src="/images/background/v2/Mountain_3.svg" />
						</object>
					</div>
					<div
						className="svg-wrap layer mountain4"
						data-travel="200"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_4.svg"
							width={this._vpWidth + 1000}>
							<img src="/images/background/v2/Mountain_4.svg" />
						</object>
					</div>
					{/*

					<div
						className="svg-wrap layer trees"
						data-travel="1000"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/trees.svg"
							width={this._vpWidth + 1000}>
							<img src="/images/background/v2/trees.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain1"
						data-travel="400"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_1.svg"
							width={this._vpWidth + 400}>
							<img src="/images/background/v2/Mountain_1.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain2"
						data-travel="600"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_2.svg"
							width={this._vpWidth + 600}>
							<img src="/images/background/v2/Mountain_2.svg" />
						</object>
					</div>

					<div
						className="svg-wrap layer mountain3"
						data-travel="800"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_3.svg"
							width={this._vpWidth + 800}>
							<img src="/images/background/v2/Mountain_3.svg" />
						</object>
					</div>
					<div
						className="svg-wrap layer mountain4"
						data-travel="200"
						data-reverse="true"
						ref={this.addLayer}
						style={vEffects.shift()}>
						<object
							data="/images/background/v2/Mountain_4.svg"
							width={this._vpWidth + 1000}>
							<img src="/images/background/v2/Mountain_4.svg" />
						</object>
					</div> */}
				</div>
			</div>
		);
	}
}
